import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "../../modules/products/productDetail.css";
import { fetchStateList } from "../../redux/actions/commonActions";
import { AdminButton } from "../buttons/versionHistoryBtn";
import DoctorProductsTableModal from "../products/doctorProductTbaleModal";
import PharmacyProductsTableModal from "../products/pharmacyProductTableModal";

const ProductOffer = ({ offersList, holding_value_unit, offerType }) => {
  const dispatch = useDispatch();
  const offer_type = localStorage.getItem("offer_type");
  const [doctorProductsOpen, setDoctorProductsOpen] = useState(false);
  const [pharmacyProductsOpen, setPharmacyProductsOpen] = useState(false);
  const [selectedOfferList, setSelectedOfferList] = useState([]);
  const [selectedOfferDetails, setSelectedOfferDetails] = useState({});

  return (
    <>
      <div className="basic-details-container-two ">
        <p className="basic-title">Offers, Quantity and Pricing Details</p>
      </div>

      <div className="product-details-container text-nowrap">
        <div className="px-2 ms-1 py-1 fs_14">
          <p className="color_262c3d fn_Nunito">
            Offer Type :
            <span className="color_2ad3e7 ms-2 fw_500">
              {offerType == "quantity"
                ? "Off Quantity"
                : offerType == "discount"
                ? "Off Discount"
                : offerType == "price"
                ? "Off Price"
                : ""}
            </span>
          </p>
        </div>

        {offersList?.length > 0 &&
          offersList?.map(
            (ele) =>
              ele?.is_default == true && (
                <div className="default-container ms-1">
                  <span className="default-text pt-2">Default</span>
                  {ele?.offers?.length > 0 &&
                    ele?.offers?.map((ex, idx) => (
                      <div className="d-flex align-items-center gap-lg-4">
                        <div className="id-container ">
                          <p className="label-id color_747f9e">ID</p>
                          <p className="id-number">#{idx + 1}</p>
                        </div>
                        <div className="d-flex overflow-auto align-items-center  pb-2 ">
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">Min Qty</p>
                            <p className="id-number">
                              {ex?.min_qty} {holding_value_unit}
                            </p>
                          </div>
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">Max Qty</p>
                            <p className="id-number">
                              {ex?.max_qty} {holding_value_unit}
                            </p>
                          </div>
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">
                              Integral Qty
                            </p>
                            <p className="id-number">{ex?.integral_qty}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">MRP</p>
                            <p className="id-number">₹ {ex?.mrp}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">PTR</p>
                            <p className="id-number">₹ {ex?.ptr}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">PTS</p>
                            <p className="id-number">₹ {ex?.pts}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">
                              {offerType == "price" && "Offer"}
                              {offerType == "quantity" && "Quantity"}
                              {offerType == "discount" && "Discounts"}
                            </p>
                            <p className="id-number">
                              {offerType == "price" &&
                                ex?.offer &&
                                `₹ ${ex?.offer}`}
                              {offerType == "quantity" &&
                                ex?.offer &&
                                `${ex?.offer}`}
                              {offerType == "discount" &&
                                ex?.offer &&
                                `${ex?.offer} %`}
                            </p>
                          </div>

                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">
                              {offerType == "price" && "Off Price"}
                              {offerType == "quantity" && "Off Quantity"}
                              {offerType == "discount" && "Off Discount"}
                            </p>
                            <p className="id-number">
                              {offerType == "price" &&
                                ex?.after_off &&
                                `₹ ${ex?.after_off}`}
                              {offerType == "quantity" &&
                                ex?.offer_qty &&
                                `${ex?.offer_qty}`}
                              {offerType == "discount" &&
                                ex?.after_off &&
                                `₹ ${ex?.after_off}`}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )
          )}

        {offersList?.length > 0 &&
          offersList?.map(
            (ele) =>
              ele?.is_default == false && (
                <div className="default-container ms-1 mb-4">
                  <span className="default-text pt-2">{ele?.state?.name}</span>
                  {ele?.offers?.length > 0 &&
                    ele?.offers?.map((ex, idx) => (
                      <div className="d-flex gap-lg-4">
                        <div className="id-container ">
                          <p className="label-id color_747f9e">ID</p>
                          <p className="id-number">#{idx + 1}</p>
                        </div>
                        <div className="d-flex overflow-auto  pb-2 ">
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">Min Qty</p>
                            <p className="id-number">
                              {ex?.min_qty} {holding_value_unit}
                            </p>
                          </div>
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">Max Qty</p>
                            <p className="id-number">
                              {ex?.max_qty} {holding_value_unit}
                            </p>
                          </div>
                          <div className="id-container-w1">
                            <p className="label-id color_747f9e">
                              Integral Qty
                            </p>
                            <p className="id-number">{ex?.integral_qty}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">MRP</p>
                            <p className="id-number">₹ {ex?.mrp}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">PTR</p>
                            <p className="id-number">₹ {ex?.ptr}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">PTS</p>
                            <p className="id-number">₹ {ex?.pts}</p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">Offer type</p>
                            <p className="id-number text-capitalize">
                              {ex.offer_type}
                            </p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">
                              {ex.offer_type == "price" && "Offer"}
                              {ex.offer_type == "quantity" && "Quantity"}
                              {ex.offer_type == "discount" && "Discounts"}
                            </p>
                            <p className="id-number">
                              {ex.offer_type == "price" &&
                                ex?.offer &&
                                `₹ ${ex?.offer}`}
                              {ex.offer_type == "quantity" &&
                                ex?.offer &&
                                `${ex?.offer}`}
                              {ex.offer_type == "discount" &&
                                ex?.offer &&
                                `${ex?.offer} %`}
                            </p>
                          </div>
                          <div className="id-container-w2">
                            <p className="label-id color_747f9e">
                              {ex.offer_type == "price" && "Off Price"}
                              {ex.offer_type == "quantity" && "Off Quantity"}
                              {ex.offer_type == "discount" && "Off Discount"}
                            </p>
                            <p className="id-number">
                              {ex.offer_type == "price" &&
                                ex?.after_off &&
                                `₹ ${ex?.after_off}`}
                              {ex.offer_type == "quantity" &&
                                // ex?.after_off &&
                                `${ex?.offer_qty}`}
                              {ex.offer_type == "discount" &&
                                ex?.after_off &&
                                `₹ ${ex?.after_off}`}
                            </p>
                          </div>
                          <div className="d-flex align-items-center">
                            <AdminButton
                              background="#7065E4"
                              color="white"
                              width="180px"
                              onClick={() => {
                                setDoctorProductsOpen(true);
                                setSelectedOfferList(ele.offers);
                                setSelectedOfferDetails(ex);
                              }}
                            >
                              <span className="m-2 fw_700">VIEW DOCTORS</span>
                            </AdminButton>
                            <AdminButton
                              background="#2AD3E7"
                              color="white"
                              width="180px"
                              onClick={() => {
                                setPharmacyProductsOpen(true);
                                setSelectedOfferList(ele.offers);
                                setSelectedOfferDetails(ex);
                              }}
                            >
                              <span className="m-2 fw_700">VIEW PHARMACY</span>
                            </AdminButton>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )
          )}
      </div>

      <DoctorProductsTableModal
        show={doctorProductsOpen}
        selectedOfferList={selectedOfferList}
        selectedOfferDetails={selectedOfferDetails}
        ShowClose={() => setDoctorProductsOpen(false)}
        ShowOpen={() => setDoctorProductsOpen(true)}
      />
      <PharmacyProductsTableModal
        show={pharmacyProductsOpen}
        selectedOfferList={selectedOfferList}
        selectedOfferDetails={selectedOfferDetails}
        ShowClose={() => setPharmacyProductsOpen(false)}
        ShowOpen={() => setPharmacyProductsOpen(true)}
      />
    </>
  );
};

export default ProductOffer;
